import {initItemcardImages} from "../../../default/global/js/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {removeAttributeWithoutValue} from "../../../ragaller_global/js/removeAttributeWithoutValue";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();
    removeAttributeWithoutValue();

    for (let item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
    }
});